module.exports = __webpack_public_path__ + "assets/img/2604.11dcc5b4.svg";